import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String }
  static targets = ["countdown"]

  connect() {
    this.remaining = 3
    this.timer = setInterval(() => this.tick(), 1000)
  }

  disconnect() {
    if (this.timer) clearInterval(this.timer)
  }

  tick() {
    this.remaining -= 1
    if (this.hasCountdownTarget) {
      this.countdownTarget.textContent = this.remaining
    }
    if (this.remaining <= 0) {
      clearInterval(this.timer)
      window.location.href = this.urlValue
    }
  }
}
